export const EMPTY_CHART_COLOR = {
    color: '#ededed',
    transparent: 'rgba(255, 255, 255, 0)',
};
